module.exports = __webpack_public_path__ + "static/media/nav_logo.9a220aff.png";